import { computed, getCurrentInstance, ref } from '@vue/composition-api';

export const useQueryParams = () => {
  const vm = getCurrentInstance();
  const store = vm.proxy.$store;
  const route = vm.proxy.$route;
  const router = vm.proxy.$router;

  const clearQueryParams = () => {
    store.commit('CLEAR_QUERY_PARAMS');
  }
  const createWatcher = () => {
    store.subscribe((mutation, state) => {
      if (mutation && mutation.payload && mutation.payload.path) {
        let path = mutation.payload.path
        if ((eagerQueryParams.value !== false) && path && path.indexOf('queryParams') >= 0) {
          pushQueryParams();
        }
      }
    })
  }
  const defaultQueryParams = ref({});
  const eagerQueryParams = ref(false);
  // the replaces the created() method from the mixin and should be called in OBM
  const initQueryParams = (defaultParams = {}, eagerParams = false) => {
    defaultQueryParams.value = defaultParams;
    eagerQueryParams.value = eagerParams;
    loadQueryParams().then(() => {
      createWatcher();
    })
  }
  const loadQueryParams = () => {
    let params = {};
    if(defaultQueryParams.value) {
      params = defaultQueryParams.value;
    }
    // console.log(`LQP`, { ...params, ...route.query });
    return store.dispatch('LOAD_QUERY_PARAMS', { ...params, ...route.query });
  }
  const queryParams = computed(() => store.getters['queryParams']);
  const pushQueryParams = async () => {
    let query = { ...store.getters['queryParams'] };
    let name = route.name;
    console.log(`name`, name, `query`, query);
    return router.push({name, query }).catch((e) => {
      if(e.name !== 'NavigationDuplicated') {
        throw e;
      }
    });
  }

  // watch(route, () => {
  //   loadQueryParams();
  // });

  return {
    clearQueryParams,
    initQueryParams,
    loadQueryParams,
    pushQueryParams,
    queryParams,
  }
}